import React from "react";
import { ResultRecord } from "andculturecode-javascript-core";
import { t } from "utilities/localization/t";
import "./add-bulk-group-users-status-form.scss";
import { BulkGroupUsersSummaryRecord } from "../../../../../../../models/view-models/groups/bulk-group-users-summary-record";
import { AddBulkGroupUsersModalStage, AddBulkGroupUsersModalStageStatusMap } from "../../../../../../../models/enumerations/groups/add-bulk-group-users-modal-stage";
import { AddBulkGroupUsersSummary } from "../add-bulk-group-users-summary/add-bulk-group-users-summary";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface AddBulkGroupUsersStatusFormProps {
    bulkGroupUsersResult: ResultRecord<BulkGroupUsersSummaryRecord>;
    stage: AddBulkGroupUsersModalStage;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// ------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "add-bulk-group-users-status-form";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const AddBulkGroupUsersStatusForm: React.FC<AddBulkGroupUsersStatusFormProps> = ({
    bulkGroupUsersResult,
    stage,
}) => {
    const showGroupSummary = () => {
        if (stage === AddBulkGroupUsersModalStage.Complete) {
            return (
                <AddBulkGroupUsersSummary
                    bulkGroupUsersRecord={bulkGroupUsersResult.resultObject}
                />
            );
        } else if (stage === AddBulkGroupUsersModalStage.Errored) {
            return (
                <div>
                    <h6>{t("errorMessageColon")}</h6>
                    {bulkGroupUsersResult.errors?.map((err, idx) => (
                        <div key={idx}>{err.message}</div>
                    ))}
                </div>
            );
        }
    };

    return (
        <div className={CSS_CLASS_NAME}>
            <h6>{t("importStatus")}</h6>
            <div className={`${CSS_CLASS_NAME}__message`}>
                {t(AddBulkGroupUsersModalStageStatusMap[stage])}
            </div>
            {showGroupSummary()}
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AddBulkGroupUsersStatusForm };

// #endregion Exports
